import { FC } from "react"
import { Auditorias } from "../modules/Auditorias/Auditorias"

export const AuditoriasWrapper: FC = () => {
    return(
        <>
            <Auditorias/>
        </>
    )
}